import {RequiredLanguageProfile} from '../shared-types';

export enum ModuleTypes {
  ScreeningApplicants = 'ScreeningApplicantModule',
  RecruitingModule = 'RecruitingModule',
  CultureModule = 'CultureModule',
  WorkforceModule = 'WorkforceModule',
}

export interface CompanyModule {
  resourceId: string;
  displayOrder: number | null;
  createdAt: string;
  enabled: boolean;
  identifier: string;
  name: RequiredLanguageProfile;
  tier: string;
  metaData: object | null;
}

type ScreeningApplicantMetaData = {
  currentApplicantCount: number;
  maxApplicantLimit: number;
};

export interface ScreeningApplicantModule extends CompanyModule {
  metaData: ScreeningApplicantMetaData;
}

export const isScreeningApplicantModule = (module: CompanyModule): module is ScreeningApplicantModule => {
  return module.identifier === ModuleTypes.ScreeningApplicants;
};
